import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { FetchArgs } from 'src/app/shared/models/core';
import { generateQueryString } from 'src/app/shared/utilities/grid-query-params';
import { combine } from 'src/app/shared/utilities/route';
import { ProfileRequirement } from '../models/profile-requirements.model';
import { AvaiableStateForRequirement } from '../models/state-requirement.model';

/**
 * @deprecated Do not use this service.  Use service(s) from "src/app/compliance/api" or "src/app/compliance/api/migration"
 */
@Injectable({ providedIn: 'root' })
export class StateRequirementService {
    private readonly _coreApiPath: string;

    constructor(@Inject(APP_CONFIG) readonly _settings: Settings, private readonly _httpClient: HttpClient) {
        this._coreApiPath = combine(_settings.coreAPIUrl, 'ayanova/compliance/state-requirements');
    }

    // ** StateRequirementController.GetAvailableStatesAsync
    public getAvailableStateForRequirements(args: FetchArgs) {
        return this._httpClient.get<AvaiableStateForRequirement[]>(
            `${this._coreApiPath}/available-states`.concat(generateQueryString(args))
        );
    }

    // ** StateRequirementController.GetStateGlobalRequirements
    public getStateGlobalRequirements(stateId: number, args: FetchArgs) {
        return this._httpClient.get<ProfileRequirement[]>(
            `${this._coreApiPath}/${stateId}/requirements`.concat(generateQueryString(args))
        );
    }
}
